// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-dropdown[data-v-30b87e36]{background:#fff;padding:50px;display:block;position:absolute;left:-100px;width:250px}.account-dropdown h6[data-v-30b87e36]{font-size:12px;font-weight:600;margin-bottom:20px;text-transform:uppercase;color:#9096a0}.dropdown-footer[data-v-30b87e36]{display:flex;justify-content:space-between;margin-top:50px}.dropdown-footer a[data-v-30b87e36]{display:inline-block;color:#002560;font-size:12px;border-bottom:1px solid #002560;font-weight:500}\n", ""]);
// Exports
module.exports = exports;
